module.exports = __webpack_public_path__ + "static/media/product3.106c08d6.png";